import { AppBar, Box, Toolbar, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Icons from "../Icons/icons";
import "./NavBar.scss";
function NavBar({ backButtonUrl = null }) {
  const navigate = useNavigate();
  return (
    <AppBar
      position="static"
      classes={{
        root: "navigation-bar",
      }}
    >
      <Toolbar variant="dense" classes={{ root: "tool-bar" }}>
        <Box className="back-button-container">
          {backButtonUrl && <Box className="navbar-back-btn">{<Icons.back_arrow onClick={() => navigate(backButtonUrl)} />}</Box>}
        </Box>
        <Box className="logo-container">
          <Icons.insightiq_logo />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default NavBar;
